import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import href from '#utilities/js/ea/href.js'
import globals from '#utilities/js/ea/globals.js'
import {refresh} from '#components/generics/js/selectors/refresh.js'
import * as utilities from '#utilities/js/styles.js'
import {scope, scopeNode} from '#components/generics/js/selectors/scope.js'
import { stop as ctrlStop} from './controls/stop.js'

import stop from './stop.js'
import scopeWs from './scopews.js'
import { meetProps } from './props.js'

export default (elem) => {
  const node = scopeNode(elem, 'contracts.chat.mains.meet')
  if (node) {
    const scopeProps = scope(node)
    const {
      dial,
      is_caller,
      msgs,
      meet_id,
      thread_id,
      join,
      useTimeout = false
    } = scopeProps
    if (dial) {
      const video = one('#largevideo', elem)
      video && video.classList.add(utilities.modifiers.display.none)
    }
    if (is_caller || join) {
      scopeWs(elem, scopeProps)
    } else if (useTimeout) {
      setTimeout(() => {
        const { st } = meetProps()
        if (st === "init") {
          ctrlStop()
        }
      }, 30000)
    }
    refresh(msgs.quit, async () => {
      const [promise, {resolve}] = resolvable()
      const url = href('chat/meet_end', {id: meet_id, thread: thread_id, done: 1})

      globals.ea_link_direct(url, 'refresh', resolve)
      await promise
      stop()
    })
    globals.ea_link_msg_set(msgs.quit);
  }
}
